import { VorschlagAbsatzDto, VorschlagArtikelDto, VorschlagModulDto, VorschlagPlatzierungDto, VorschlagSortimentDto } from "@sortapp/app/api/advsortiment/models";
import { CommonCheckService, SortimentDtoClient } from "FoxxyLib";



// "datum":"2024-11-25T00:00:00","catalogProductNumber":"00000000000056344542","ean":"9783356025255","titel":"SOKO Wismar","verlag":"Hinstorff Verlag GmbH","autor":"Mück, Moni; Pfau, Anna","preis":24,"sortimente":[{"datum":"2024-11-25T00:00:00","catalogProductNumber":"00000000000056344542","sortimentId":16036,"sortimentName":"Reise_Regional_Schwerin/UNR/WLW","sortierwert":1517936.64,"module":[{"datum":"2024-11-25T00:00:00","catalogProductNumber":"00000000000056344542","sortimentId":16036,"modul":1,"platzierungAktuell":{"stellplaetze":0},"platzierungVorschlag":{"stellplaetze":1,"platzierungsart":"Stapel"},"sortierwert":1517936.64}]}],"sortierwert":1517936.64,"absaetze":[{"catalogProductNumber":"00000000000056344542","datum":"2024-11-25T00:00:00","absatzStart":"0001-01-01T00:00:00","absatzName":"Gesamt","absatzEnde":"0001-01-01T00:00:00","fisMenge":48,"fisUmsatz":1152,"mcMenge":274,"mcUmsatz":6576},{"catalogProductNumber":"00000000000056344542","datum":"2024-11-25T00:00:00","absatzStart":"2024-11-04T00:00:00","absatzName":"KW45","absatzEnde":"2024-11-10T00:00:00","fisMenge":11,"fisUmsatz":264},{"catalogProductNumber":"00000000000056344542","datum":"2024-11-25T00:00:00","absatzStart":"2024-11-11T00:00:00","absatzName":"KW46","absatzEnde":"2024-11-17T00:00:00","fisMenge":15,"fisUmsatz":360},{"catalogProductNumber":"00000000000056344542","datum":"2024-11-25T00:00:00","absatzStart":"2024-11-18T00:00:00","absatzName":"KW47","absatzEnde":"2024-11-24T00:00:00","fisMenge":11,"fisUmsatz":264},{"catalogProductNumber":"00000000000056344542","datum":"2024-11-25T00:00:00","absatzStart":"2024-11-25T00:00:00","absatzName":"KW48","absatzEnde":"2024-12-01T00:00:00","fisMenge":11,"fisUmsatz":264}]}'


export class VorschlagFlatDtoClient {
  sortiment: SortimentDtoClient = null;
  pivot: Array<VorschlagPivotDtoClient> = [];
  sortierwert: number = 0;

  constructor(dtos: VorschlagArtikelDto[], userssortiment: SortimentDtoClient, commonvalidate : CommonCheckService) {
    try {
    this.sortiment = userssortiment;
    const distinctSortimente = Array<VorschlagSortimentDtoClient>();
    let mxmodule = 0;
    for (let index = 0; index < dtos.length; index++) {
      const element = dtos[index];
      for (let y = 0; y < element.sortimente.length; y++) {
        const sortiment = element.sortimente[y];
        if (       //nur angefragtes Sortiment des Users
          userssortiment.id == sortiment.sortimentId
        ) {
          distinctSortimente.push(new VorschlagSortimentDtoClient(sortiment, element, commonvalidate));
          mxmodule = Math.max(mxmodule, Math.max(...sortiment.module.map(d => d.modul)));

          break;
        }
      }
    }

    for (let index = 0; index < dtos.length; index++) {
      const dto = dtos[index];
      for (let y = 0; y < dto.sortimente.length; y++) {
        const sortiment = dto.sortimente[y];
        // if (userssortiment.cockpitSuggestions  == undefined || userssortiment.cockpitSuggestions-1 < this.pivot.length) {
        //     //Hier Count suggestions berücksichtigen
        //     break;
        // }
        if (       //nur angefragtes Sortiment des Users
          userssortiment.id == sortiment.sortimentId
          && this.pivot.find(d => d.catalogProductNumber == dto.catalogProductNumber) == null
        ) {
          const newRow = <VorschlagPivotDtoClient>{
            sortimentId: this.sortiment.id, sortimentName: this.sortiment.name,
            sortierwert: dto.sortierwert,
            titel: dto.titel, catalogProductNumber: dto.catalogProductNumber, ean: dto.ean
          };

          const modulinfos : ModulinfotDtoClient[] = [];
          for (let i = 1; i <= mxmodule; i++) {
            const vorschlag = sortiment.module.find(m => m.modul == i);
            modulinfos.push({ modul: i,
              platzierungVorschlag: vorschlag?.platzierungVorschlag,
              platzierungAktuell: vorschlag?.platzierungAktuell,
             });
          }
          newRow.modulinfos = modulinfos;
          this.pivot.push(newRow);
        }
      }
    }

} catch(e) {
        console.debug("Error in VorschlagFlatDtoClient", e);
        throw e;
}
  }

}

export class VorschlagPivotDtoClient {
  sortimentId: number;
  sortimentName: string;
  sortierwert: number;
  modulinfos: ModulinfotDtoClient[];
  titel: string;
  ean: string;
  catalogProductNumber: string;

}

export class ModulinfotDtoClient {
  modul: number;
  platzierungVorschlag: VorschlagPlatzierungDto;
  platzierungAktuell?: VorschlagPlatzierungDto;
}


export class VorschlagSortimentDtoClient implements VorschlagSortimentDto {

  constructor(dto: VorschlagSortimentDto, parent: VorschlagArtikelDto, commonvalidate : CommonCheckService) {
    this.datum = dto.datum;
    this.sortimentId = dto.sortimentId;
    this.sortimentName = dto.sortimentName;
    this.sortierwert = dto.sortierwert;
    this.catalogProductNumber = dto.catalogProductNumber;
    this.module = dto.module;
    this.titel = parent.titel;
    this.zurueckStellenBis = dto.zurueckStellenBis;
    this.id  = commonvalidate.getUniqueId();
  }

  id: number;
  titel: string;
  catalogProductNumber?: string;
  datum: string;
  geloeschtAm?: string;
  module?: VorschlagModulDto[];
  sortierwert: number;
  sortimentId: number;
  sortimentName?: string;
  zurueckStellenBis?: string;

}

export class VorschlagDtoClient {

  constructor(dto: VorschlagArtikelDto) {

    this.datum = dto.datum;
    this.catalogProductNumber = dto.catalogProductNumber;
    this.ean = dto.ean;
    this.verlag = dto.verlag;
    this.autor = dto.autor;
    this.preis = dto.preis;
    this.sortierwert = dto.sortierwert;
    this.titel = dto.titel;
    this.warengruppe = dto.warengruppe;
    this.absaetze = dto.absaetze;
    this.sortimente = dto.sortimente;
  }

  absaetze?: Array<VorschlagAbsatzDto>;
  autor?: string;
  catalogProductNumber?: string;
  datum: string;
  ean?: string;
  preis: number;
  sortierwert: number;
  sortimente?: Array<VorschlagSortimentDto>;
  titel?: string;
  verlag?: string;
  warengruppe?: string;

}



